import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GameButton from '../game-button/gameButton';

import './termActions.css';

export default class TermActions extends Component {

  render() {

    if (this.props.hidden) {
      return null;
    }

    return (<div className='term-actions'>
      <GameButton customClass='term-actions__button term-actions__button--higher' text='Higher' clickHandler={this.props.higherClickHandler} />
      <GameButton customClass='term-actions__button term-actions__button--lower' text='Lower' clickHandler={this.props.lowerClickHandler} />
      <div>searches than {this.props.previousKeyword}</div>
    </div>);
  }
}

TermActions.propTypes = {
  hidden: PropTypes.bool,
  previousKeyword: PropTypes.string,
  higherClickHandler: PropTypes.func,
  lowerClickHandler: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/term-actions/termActions.js